/**
 * Returns the reps value or reps value of a set,
 * for example: "2-4" if it's a range, or 4 if it's just a single value
 *
 * @param reps {Number} reps value of a set
 * @param repsLower {Number} repsLower value of a set
 * @returns {String} reps value
 */
export const repsValue = (reps, repsLower) => {
  if (repsLower) return `${repsLower}-${reps}`;
  return reps ? String(reps) : "-";
};
